module.exports = __webpack_public_path__ + "static/media/winter_1.eb938934.jpg";